import { jsx as g } from "react/jsx-runtime";
import { r as m, C as b } from "../../index-D8rQzb7O.js";
import { createContext as y, useState as s, useEffect as x, useContext as C } from "react";
const D = m("Device", {
  web: () => import("../../web-PWernkEB.js").then((e) => new e.DeviceWeb())
}), i = m("PushNotifications", {}), h = y(void 0), E = ({ children: e }) => {
  const [n, a] = s(), [c, d] = s(!1), [f, o] = s(null), [r, u] = s([]), [l, w] = s();
  x(() => {
    (async () => {
      if (b.isNativePlatform()) {
        await v(), await P();
        const t = await D.getInfo();
        o(t.platform === "android" ? 1 : 2);
      } else
        o(0);
    })();
  }, []);
  const P = async () => {
    let t = await i.checkPermissions();
    t.receive === "prompt" && (t = await i.requestPermissions()), t.receive !== "granted" && console.error("User denied permissions!"), await i.register();
  }, v = async () => {
    await i.addListener("registration", (t) => {
      console.info("Registration token: ", t.value), a(t.value);
    }), await i.addListener("registrationError", (t) => {
      console.error("Registration error: ", t.error), d(!0);
    }), await i.addListener("pushNotificationReceived", (t) => {
      const N = p(t);
      u([...r, N]);
    }), await i.addListener("pushNotificationActionPerformed", (t) => {
      const N = p(t.notification);
      w(N);
    });
  };
  return /* @__PURE__ */ g(h.Provider, { value: { token: n, pushNotifications: r, deviceType: f, tokenError: c, actionedNotification: l, setPushNotifications: u }, children: e });
}, p = (e) => {
  const { body: n, title: a, schoolcode: c, schoolname: d, type: f, studentid: o, id: r } = e.data;
  return {
    NotificationID: Number(r),
    ObjectID: Number(e.data.objectid),
    Properties: e.data.properties ? JSON.parse(e.data.properties) : {},
    Message: n || "",
    Title: a || "",
    NotificationType: Number(f),
    StudentID: o ? Number(o) : void 0,
    SchoolCode: c,
    SchoolName: d
  };
}, L = () => {
  const e = C(h);
  if (!e)
    throw new Error("useNotifications must be used within an NotificationProvider");
  return e;
};
export {
  E as PushNotificationContextProvider,
  L as usePushNotifications
};
//# sourceMappingURL=index.js.map
